<template>
  <div>
    <div :class="dialog_colaborador.aberto || dialog_exluir ? 'blur' : ''">
      <div class="header">
        <div>
          <h1>Colaboradores</h1>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
            <el-breadcrumb-item>Colaboradores</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="espaco" />
        <el-switch v-model="colaborador_desativado" :active-text="colaborador_desativado ? 'Ver colaboradores ativos' : 'Ver colaboradores inativos'"
          class="mt-xs-4 mt-md-0">
        </el-switch>
        <div class="espaco" />
        <div>
          <el-button icon="el-icon-plus" class="botao mt-xs-4 mt-sm-0" @click="cadastrarColaborador">
            <span>Adicionar Colaborador</span>
          </el-button>
        </div>
      </div>

      <div v-if="carregando" class="carregando">
        <i class="el-icon-loading"></i>
      </div>
      <el-row v-else :gutter="30">
        <el-col :xs="24" :sm="12" :md="8" v-for="(item, index) in colaboradores_filtrados" :key="index">
          <div class="card pointer" @click="$router.push(`colaborador/${item.uid}`)" :class="!item.ativado ? 'colaborador-desativado' : ''">
            <div class="card-content">
              <div :class="item.ativado ? 'desativar' : 'config'" @click.stop="mudarStatusColaborador(item.uid, !item.ativado)">
                <i class="fas" :class="item.ativado ? 'fa-user-slash' : 'fa-user-check'"></i>
              </div>
              <div :class="item.ativado ? 'config' : 'display-none'" @click.stop="editarColaborador(item)">
                <i class="fas fa-cog"></i>
              </div>
              <div class="avatar">
                <span class="avatar-ini">{{avatar(item.nome)}}</span>
              </div>
              <div class="info">
                <p class="nome">{{item.nome}} {{item.sobrenome}}</p>
                <span v-if="item.minutosExtras === null" class="horas">
                  Não bateu ponto esse mês
                </span>
                <span v-else class="horas" :class="(item.minutosExtras >= 0) ? 'extra' : 'falta'">
                  {{(item.minutosExtras >= 0) ? 'Horas extras' : 'Devendo'}}: {{ item.horasExtras
                  }}
                </span>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <DialogColaborador v-if="dialog_colaborador.aberto" :abrirDialog="dialog_colaborador"
      :colaboradorSelecionado="colaboradorSelecionado" :editar="editaColaborador" />
  </div>
</template>

<script>
import moment from 'moment';
import { calculaHorasMesColaborador } from '../config/functions';
import DialogColaborador from './colaborador/dialog-colaborador.vue';

export default {
  components: { DialogColaborador },
  data() {
    return {
      carregando: true,
      dialog_colaborador: { aberto: false },
      dialog_exluir: false,
      colaboradores: [],
      colaboradorSelecionado: {},
      editaColaborador: false,
      colaborador_desativado: false,
      dia: moment()
    };
  },
  created() {
    const ref = this.$db.ref('colaboradores/');
    ref.on('value', snap => {
      const colaboradores = Object.values(snap.val());

      const promises = [];

      colaboradores.forEach(colaborador => {
        promises.push(calculaHorasMesColaborador(this.dia, colaborador.uid, colaborador.horasSemana));
      });

      Promise.all(promises).then(resolves => {
        for (let i = 0; i < resolves.length; i += 1) {
          colaboradores[i].minutosExtras = resolves[i] ? resolves[i].minutos_extras : null;
          colaboradores[i].horasExtras = resolves[i] ? resolves[i].horas_extras : null;
          this.colaboradores.push(colaboradores[i]);
        }

        this.colaboradores.sort((a, b) => {
          if (a.nome > b.nome) return 1;
          if (a.nome < b.nome) return -1;
          return 0;
        });

        this.carregando = false;
      });
    });
  },
  methods: {
    editarColaborador(colaborador) {
      this.editaColaborador = true;
      this.colaboradorSelecionado = colaborador;
      this.dialog_colaborador.aberto = true;
    },
    cadastrarColaborador() {
      this.editaColaborador = false;
      this.dialog_colaborador.aberto = true;
    },
    mudarStatusColaborador(uid, status) {
      this.dialog_exluir = true;

      const tipo = status ? 'ativar' : 'desativar';

      this.$confirm(`Você irá ${tipo} o colaborador, Deseja continuar?`, `${tipo.charAt(0).toUpperCase() + tipo.slice(1)} colaborador`, {
        confirmButtonText: tipo.charAt(0).toUpperCase() + tipo.slice(1),
        cancelButtonText: 'Cancelar',
        cancelButtonClass: 'botao-cancelar',
        confirmButtonClass: 'botao',
        type: status ? 'info' : 'warning',
        center: true,
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            // eslint-disable-next-line
            instance.confirmButtonLoading = true;
            this.$db.ref(`colaboradores/${uid}/`).update({
              ativado: status
            }, error => {
              if (error) this.$message.error(`${error.code} - ${error.message}`);
            });
            done();
            // eslint-disable-next-line
            instance.confirmButtonLoading = false;
          } else done();
        }
      }).then(() => {
        this.$message.success(`Colaborador ${tipo} com sucesso.`);
        this.dialog_exluir = false;
      }).catch(() => {
        this.dialog_exluir = false;
      });
    },
    avatar(nome) {
      return nome.charAt(0);
    }
  },
  computed: {
    colaboradores_filtrados() {
      return this.colaboradores.filter(item => item.ativado === !this.colaborador_desativado);
    }
  }
};
</script>

<style lang="scss" scoped>
.colaborador-desativado {
  border-color: rgba(#ffffff, 0.07);

  .avatar {
    background: #888 !important;
    opacity: 0.4;
  }

  .info {
    opacity: 0.4;
  }
}
</style>
